/* ============
 * Locale Module State
 * ============
 */

export default {
  current: 'en',
  default: 'en'
}



// WEBPACK FOOTER //
// ./src/app/store/modules/locale/state.js